import { server } from "../api";
import axios from "axios";

/**
 * 取得設備列表
 */
const getDevices = async (deviceID, estate_id) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${deviceID}/cameras`);
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};

/**
 * 取得設備組列表
 */
const getDevicesGroup = async () => {
  try {
    const response = await axios.get(`${server}v1/entrance/devices_groups`);
    return response.data;
  } catch (error) {
    console.error("Error fetching devices:", error);
    throw error;
  }
};

/**
 * 新增設備
 */
const addDevice = async (deviceID, deviceData) => {
  try {
    const response = await axios.put(`${server}v1/entrance/camera`, {
      mobile_id: deviceID,
      name: deviceData.name,
      device_sn: deviceData.device_sn || '',
    });
    return response.data;
  } catch (error) {
    console.error("Error adding device:", error);
    throw error;
  }
};

/**
 * 編輯設備
 */
const updateDevice = async (cameraID, deviceData) => {
  try {
    const response = await axios.post(`${server}v1/entrance/camera/${cameraID}`, {
      name: deviceData.name,
      device_sn: deviceData.device_sn || '',
    });
    return response.data;
  } catch (error) {
    console.error("Error updating device:", error);
    throw error;
  }
};

/**
 * 刪除設備
 */
const deleteDevice = async (cameraID) => {
  try {
    const response = await axios.delete(`${server}v1/entrance/camera/${cameraID}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting device:", error);
    throw error;
  }
};

/**
 * 取得人員名冊
 */
const getPersonnel = async (estateID, device_id) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${estateID}/${device_id}/personnel`);
    return response.data;
  } catch (error) {
    console.error("Error fetching personnel:", error);
    throw error;
  }
};

/**
 * 取得本地人員資料（含IoT3自訂欄位）
 */
const getLocalPersonnel = async (deviceID, params = {}) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${deviceID}/personnel/local`, {
      params: {
        page: params.page || 1,
        limit: params.limit || 10,
        keywords: params.keywords || '',
        device_sn: params.device_sn || '',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching local personnel:", error);
    throw error;
  }
};

/**
 * 更新人員自訂欄位
 */
const updatePersonnelCustomFields = async (personnelID, customData) => {
  try {
    const response = await axios.post(`${server}v1/entrance/personnel/${personnelID}`, customData);
    return response.data;
  } catch (error) {
    console.error("Error updating personnel custom fields:", error);
    throw error;
  }
};

/**
 * 新增人員
 */
const addPersonnel = async (mobile_id, personnelData) => {
  try {
    const response = await axios.post(`${server}v1/entrance/personnel/add/${mobile_id}`, personnelData);
    return response.data;
  } catch (error) {
    console.error("Error adding personnel:", error);
    throw error;
  }
};


/**
 * 刪除人員
 */

const deletePersonnel = async (personnelID) => {
  try {
    const response = await axios.delete(`${server}v1/entrance/personnel/${personnelID}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting personnel:", error);
    throw error;
  }
};

/**
 * 取得進出記錄
 */
const getRecords = async (deviceID, params = {}) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${deviceID}/records`, {
      params: {
        start_date: params.start_date,
        end_date: params.end_date,
        page: params.page || 1,
        keywords: params.keywords || '',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching records:", error);
    throw error;
  }
};

/**
 * 取得今日進出記錄
 */
const getTodayRecords = async (deviceID, params = {}) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${deviceID}/records/today`, {
      params: {
        page: params.page || 1,
        limit: params.limit || 100,
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching today records:", error);
    throw error;
  }
};

/**
 * 取得今日統計
 */
const getStats = async (deviceID) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${deviceID}/records/stats`);
    return response.data;
  } catch (error) {
    console.error("Error fetching stats:", error);
    throw error;
  }
};

/**
 * 取得陌生人記錄
 */
const getStrangers = async (deviceID, params = {}) => {
  try {
    const response = await axios.get(`${server}v1/entrance/${deviceID}/strangers`, {
      params: {
        start_date: params.start_date,
        end_date: params.end_date,
        page: params.page || 1,
        limit: params.limit || 10,
        keywords: params.keywords || '',
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching strangers:", error);
    throw error;
  }
};


/**
 * 取得部門列表
 */
const getDepartments = async () => {
  try {
    const response = await axios.get(`${server}v1/entrance/departments`);
    return response.data;
  } catch (error) {
    console.error("Error fetching departments:", error);
    throw error;
  }
};

/**
 * 取得所屬場域
 */
const getEstate = async (deviceID) => {
  try {
    const response = await axios.get(`${server}v1/entrance/estate/${deviceID}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching estate:", error);
    throw error;
  }
};


const getSentDevice = async (userData) => {
  try {
    const response = await axios.post(`${server}/v1/entrance/SentDevice`, userData);
    return response.data;
  } catch (error) {
    console.error("Error fetching estate:", error);
    throw error;
  }
};

const sendToDevice = async (sendData) => {
  try {
    const response = await axios.post(`${server}/v1/entrance/sentToDevice`, sendData);
    return response.data;
  } catch (error) {
    console.error("Error fetching estate:", error);
    throw error;
  }
};

const deleteUserInDevice = async (delData) => {
  try {
    const response = await axios.post(`${server}/v1/entrance/deleteUserInDevice`, delData);
    return response.data;
  } catch (error) {
    console.error("Error fetching estate:", error);
    throw error;
  }
};

const openDoor = async (device_sn) => {
  try{
    const response = await axios.post(`${server}/v1/entrance/openDoor/${device_sn}`);
    return response.data;
  } catch(error){
    console.error(error);
    throw error;
  }
};

const currentScreen = async (device_sn) => {
  try{
    const response = await axios.post(`${server}/v1/entrance/current_screen/${device_sn}`);
    return response.data;
  } catch(error){
    console.error(error);
    throw error;
  }
};

export default {
  getDevices,
  addDevice,
  updateDevice,
  deleteDevice,
  getPersonnel,
  getLocalPersonnel,
  updatePersonnelCustomFields,
  getRecords,
  getTodayRecords,
  getStats,
  getStrangers,
  getDepartments,
  deletePersonnel,
  getEstate,
  addPersonnel,
  getDevicesGroup,
  getSentDevice,
  sendToDevice,
  deleteUserInDevice,
  openDoor,
  currentScreen,
};